export const saveToken=(token)=>{
    localStorage.setItem("token",token)
}
export const getToken=()=>{
    return localStorage.getItem("token")
}
export const getUserName=()=>{
    return localStorage.getItem('username')
}
export const saveUserName=(username)=>{
    return localStorage.setItem('username',username)
}
export const saveUserId=(userid)=>{
    localStorage.setItem("userid",userid)

}
export const getUserId=()=>{
    return localStorage.getItem("userid")

}

export const getUserStatus=()=>{
    return localStorage.getItem("userstatus")
}
export const saveUserStatus=(status)=>{
    return localStorage.setItem("userstatus",status)
}
export const isLogined=()=>{
    if(getToken()){
        return true;
    }
    return false;
}
